var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon5BlogBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.97,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.84 12.03h18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.85 1.97c5.75 0 7.4 2.81 7.87 4.42H3.97c.47-1.6 2.12-4.42 7.88-4.42m0-1.97C4.6 0 2.6 4.08 2.08 5.83a1.97 1.97 0 0 0 1.89 2.53h15.75a1.97 1.97 0 0 0 1.88-2.53C21.08 4.08 19.1 0 11.85 0zm7.87 17.68c-.48 1.61-2.12 4.42-7.87 4.42-5.76 0-7.4-2.8-7.88-4.42h15.75m0-1.96H3.97a1.97 1.97 0 0 0-1.89 2.52c.52 1.75 2.51 5.82 9.77 5.82 7.24 0 9.24-4.07 9.75-5.82a1.96 1.96 0 0 0-1.88-2.52z",
    fill: "#000"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+DQogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgPHBhdGggc3Ryb2tlPSIjMDAwIiBzdHJva2Utd2lkdGg9IjEuOTciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0iTTIuODQgMTIuMDNoMTgiLz4NCiAgICA8cGF0aCBkPSJNMTEuODUgMS45N2M1Ljc1IDAgNy40IDIuODEgNy44NyA0LjQySDMuOTdjLjQ3LTEuNiAyLjEyLTQuNDIgNy44OC00LjQybTAtMS45N0M0LjYgMCAyLjYgNC4wOCAyLjA4IDUuODNhMS45NyAxLjk3IDAgMCAwIDEuODkgMi41M2gxNS43NWExLjk3IDEuOTcgMCAwIDAgMS44OC0yLjUzQzIxLjA4IDQuMDggMTkuMSAwIDExLjg1IDB6bTcuODcgMTcuNjhjLS40OCAxLjYxLTIuMTIgNC40Mi03Ljg3IDQuNDItNS43NiAwLTcuNC0yLjgtNy44OC00LjQyaDE1Ljc1bTAtMS45NkgzLjk3YTEuOTcgMS45NyAwIDAgMC0xLjg5IDIuNTJjLjUyIDEuNzUgMi41MSA1LjgyIDkuNzcgNS44MiA3LjI0IDAgOS4yNC00LjA3IDkuNzUtNS44MmExLjk2IDEuOTYgMCAwIDAtMS44OC0yLjUyeiIgZmlsbD0iIzAwMCIgLz4NCiAgPC9nPg0KPC9zdmc+DQo=";
export { SvgIcon5BlogBurger as ReactComponent };